import { Asset } from 'app-lib/assetUtils'
import { ookiToken } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import AssetBalance from 'shared-components/AssetBalance'
import ExternalLink from 'shared-components/ExternalLink'
import { Button } from 'ui-framework'
import RewardsVM from './RewardsVM'

export function SushiRewards({ vm }: { vm: RewardsVM }) {
  const { rewards } = vm

  return (
    <div className="flex-col height-100p">
      <h3 className="title-section">Sushi Rewards</h3>

      <AssetBalance
        className="margin-bottom-2"
        variant="green"
        balance={rewards.sushi}
        asset={Asset.SUSHI}
      />

      <p className="txt-explanation margin-bottom-2">
        <b>SUSHI</b> earned from providing liquidity to the{' '}
        <ExternalLink className="link" href={ookiToken.slp.sushiPoolLink}>
          Sushi <b>OOKI/ETH</b> Pool.
        </ExternalLink>
      </p>

      <Button
        isLoading={rewards.pendingSushiRewards}
        variant="blue"
        className="flex-col-end"
        disabled={!rewards.canClaimSushiRewards}
        onClick={rewards.claimSushiRewards}>
        Claim SUSHI
      </Button>
    </div>
  )
}

export default observer(SushiRewards)
